export default __webpack_public_path__ + "images/crossGrey.v-43944e429cbf9079b881578603916048.svg";